export class Place
{
    id       : number;
	code     : number;
	name     : string;
	nameS    : string;
	latitude : number;
	longitude: number;

	public static isKind( place: any ){
		return 	place 			&&
				place.id	 	&&
				place.code 		&&
				place.name 		&&
				place.nameS 	&&
				place.latitude 	&&
				place.longitude 
	}
}

